import { useState, useCallback } from 'react';
import API from 'api/api';
import { useFirebaseAuth } from 'domains/auth/hooks/useFirebaseAuth';

export default function useDeleteDriverFromUser() {
  const { uid } = useFirebaseAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const deleteDriver = useCallback(
    async (driverId) => {
      if (!uid) {
        setError(new Error('User not authenticated.'));
        return;
      }
      setLoading(true);
      setError(null);
      setSuccess(false);

      try {
        await API.delete(`/users/${uid}/driver/${driverId}`, driverId);
        setSuccess(true);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [uid]
  );

  return { deleteDriver, loading, error, success };
}
